//# sourceMappingURL=setup.mjs.map
/// <reference types="./setup.d.mts" />
import * as $tab_bar from "../../../altar/altar/tab_bar.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $compose from "../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $effects from "../../admin/effects/organization_setup.mjs";
import * as $route from "../../data/route.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";
import * as $config from "../../view/organization/setup/config.mjs";
import * as $prompts from "../../view/organization/setup/prompts.mjs";
import * as $setup from "../../view/organization/setup/setup.mjs";

function tab(to, title) {
  let uri = new $route.Organization(new $route.Setup(to));
  let uri$1 = $route.to_uri(uri);
  return $tab_bar.tab(uri$1, toList([$h.text(title)]));
}

export function use_setup_data() {
  let store = $store.use_state();
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => {
    return $redraw.use_effect(_capture, [store.organization]);
  })(
    () => {
      return $when.some_(
        store.organization,
        $function.always(undefined),
        (org_id) => {
          let _pipe = $store.organization_qm_rows(store);
          return $remote.load(
            _pipe,
            () => {
              dispatch($effects.fetch_qualification_matrix(org_id));
              return undefined;
            },
          );
        },
      );
    },
  );
}

export function view() {
  return $compose.static$(
    $prompts.view(),
    (prompts) => {
      return $compose.static$(
        $config.view(),
        (config) => {
          return $compose.static$(
            $setup.view(),
            (setup) => {
              return $redraw.component_(
                "Organization(Setup)",
                (_use0) => {
                  let route = _use0[0];
                  use_setup_data();
                  return $redraw.fragment(
                    toList([
                      $l.column(
                        toList([$l.gap(12)]),
                        toList([]),
                        toList([
                          $common.page_title("Organization Setup"),
                          $tab_bar.tab_bar(
                            toList([
                              tab(new $route.Config(), "Config"),
                              tab(new $route.Prompts(), "Prompts"),
                              tab(new $route.Init(), "Setup"),
                            ]),
                          ),
                        ]),
                      ),
                      (() => {
                        if (route instanceof $route.Init) {
                          return setup();
                        } else if (route instanceof $route.Config) {
                          return config();
                        } else {
                          return prompts();
                        }
                      })(),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
